import React, { FunctionComponent, ReactElement, type SVGProps } from 'react';
import styles from './Button.module.scss';

type Props = {
  text: string;
  isEnabled?: boolean;
  onClick?: () => void;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  rightIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  isSecondary?: boolean;
  style?: React.CSSProperties;
  className?: string;
  type?: 'button' | 'submit';
  heapId?: string
};

export function Button({
  text,
  isEnabled = true,
  onClick,
  icon,
  rightIcon,
  isSecondary = false,
  style,
  className,
  type = 'button',
  heapId,
}: Props): ReactElement {
  const LeftIcon = icon;
  const RightIcon = rightIcon;
  const iconFill = isSecondary ? '#000000' : '#FFFFFF';
  return (
    <button
      tabIndex={-1}
      data-heap-id={heapId}
      className={[
        styles.button,
        isSecondary && styles.secondary_button,
        !isEnabled && styles.disabled_button,
        className,
      ].join(' ')}
      type={type === 'submit' ? 'submit' : 'button'}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      disabled={!isEnabled}
      style={style}
    >
      {LeftIcon && <LeftIcon height="16" width="16" fill={iconFill} />}
      <span>{text}</span>
      {RightIcon && <RightIcon height="16" fill={iconFill} />}
    </button>
  );
}
